import React from "react";

import style from "./style.module.css";

export default function NotFoundPage() {
  return (
    <div className={style.page}>
      <h1>404 Page Not Found</h1>
    </div>
  );
}
